import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  content: {
    maxWidth: 450,
    "& .MuiBox-root": {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      gap: "10px",
      minHeight: 40,
      "& span": {
        height: 40,
        width: 40,
      },
    },
  },
}));
